import React from 'react';
import Styles from '../../css';

const Footer = () => (
    <footer style={{...Styles.footer, marginTop: 'auto', padding: '10px 0'}}>
        <a href={typeof __COMMIT_HASH__ !== 'undefined' ? `https://github.com/gur111/DCat/commit/${__COMMIT_HASH__}` : '#'} target="_blank" rel="noopener noreferrer">
            #{ typeof __COMMIT_HASH__ !== 'undefined' ? __COMMIT_HASH__ : 'dev' }
        </a>
        {' '}{ typeof __COMMIT_DATE__ !== 'undefined' ? __COMMIT_DATE__ : 'unknown' }
    </footer>
);

export default Footer;
